import React, { useState, useEffect } from "react";
import Image from "next/image";
import { m } from "framer-motion";
import Link from "next/link";
export default function ProjectCard({ project, className }) {
  const [loading, setLoading] = useState(true);
  const [currentSrc, updateSrc] = useState( project?.thumbnail?.data?.attributes?.formats?.thumbnail?.url ??
      "/images/placeholder.svg");

  const { title, projectType, year, slug } = project;
  // const url = project?.thumbnail?.data?.attributes?.formats?.medium?.url ?? project?.thumbnail?.data?.attributes?.url ?? "/images/placeholder.svg";
  const alternativeText = project?.thumbnail?.data?.attributes?.alternativeText ?? title ?? "project image";

  useEffect(() => {
    if (!project?.thumbnail?.data?.attributes?.url) return;

    // Start loading the original image
    const imageToLoad = new window.Image();
    const originalSrc = project?.thumbnail?.data?.attributes?.url;

    imageToLoad.src = originalSrc;
    imageToLoad.onload = () => {
      // When the image is loaded, replace the src and set loading to false
      updateSrc(originalSrc);
      setLoading(false);
    };
  }, [project?.thumbnail?.data?.attributes?.url]);

  return (
    <Link
      href={`/projects/${slug}`}
      className={`w-full relative group/item ${className}`}
    >
      <m.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 100, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className={`w-full h-full relative shrink-0 group transition-all duration-300 ease`}
      >
        <Image
          src={currentSrc}
          alt={alternativeText ?? title}
          sizes="(max-width: 479px) 500px, 500px"
          fill
          loading="lazy"
          quality={50}
          className={`w-full h-full object-center object-cover transition-all duration-300 ease ${
            loading ? "opacity-50 blur-md" : "opacity-100"
          }`}
        />
      </m.div>
      <div className="lg:group-hover/item:bg-black/40 lg:bg-transparent bg-black/40 lg:p-4 md:p-1 p-2 transition-all duration-500 ease w-full h-full absolute top-0 left-0 flex flex-col gap-1 items-center justify-end">
        <p className="lg:group-hover/item:translate-y-0 lg:translate-y-12 lg:opacity-0 lg:group-hover/item:opacity-100 transition-all duration-500 ease lg:text-sm text-[12px] text-[#f6f5f1] font-light text-center">
          {projectType} - {year}
        </p>
        <p className="lg:group-hover/item:translate-y-0 lg:translate-y-8 lg:opacity-0 lg:group-hover/item:opacity-100 transition-all duration-500 ease lg:text-2xl text-lg text-[#f6f5f1] font-light font-havletica text-center capitalize">
          {title}
        </p>
      </div>
    </Link>
  );
}
